import React, { useEffect, useState } from 'react';
import Texts from 'react-sdk/Texts';
import WaveSection from '../../../components/shared/WaveSection/WaveSection';
import AppState, { SCREENS } from '../../../js/AppState';
import Button from '../../../components/shared/Button/Button';
import Rays from '../../../components/shared/Rays/Rays';
import logo from "../../../images/logo.png";
import CanvasCharacter from '../../../components/Dial/CanvasCharacter/CanvasCharacter';
import Footer from '../_layouts/HomeScreens/Footer/Footer';

import classes from './ScreenFinal.module.css';
import { RiCoinLine } from 'react-icons/ri';

const ScreenFinal = () => {

  const [debriefType, setDebriefType] = useState(null)
  const [debriefCost, setDebriefCost] = useState(null)

  const [counts, setCounts] = useState(null)
  const [costs, setCosts] = useState(null)


  function handleQuit() {
    AppState.dials.setDial(null)

    AppState.nextPeriod = null
    AppState.dials.debugSkip = false
    AppState.skipIntro = false

    AppState.period = null
    AppState.selection = null
    AppState.setScreen(SCREENS.HOME)
  }

  useEffect(() => {
    let _counts = [0, 0, 0]
    let _costs = [0, 0, 0]

    if (AppState.selection) {
      AppState.selection.itemSelected.forEach(item => {
        _counts[AppState.selection.blocks.indexOf(item.blockRef)]++

        _costs[item.cost - 1]++ // le cout commence à 1 et non à 0
      })
    }

    setCounts(_counts)
    setCosts(_costs)
  }, [])

  useEffect(() => {

    if (!counts) return

    if (counts[0] === counts[1] && counts[0] === counts[2]) {
      setDebriefType("allEquals")
    }
    else if (counts[0] === counts[1] && counts[0] > counts[2]) {
      setDebriefType("g1g2Equal")
    }
    else if (counts[1] === counts[2] && counts[1] > counts[0]) {
      setDebriefType("g2g3Equal")
    }
    else if (counts[2] === counts[0] && counts[2] > counts[1]) {
      setDebriefType("g3g1Equal")
    }
    else if (counts[0] > counts[1] && counts[0] > counts[2]) {
      setDebriefType("g1More")
    }
    else if (counts[1] > counts[0] && counts[1] > counts[2]) {
      setDebriefType("g2More")
    }
    else if (counts[2] > counts[0] && counts[2] > counts[1]) {
      setDebriefType("g3More")
    }
    else {
      console.warn("Erreur dans ScreenFinal")

      setDebriefType("allEquals")
    }
  }, [counts])

  useEffect(() => {
    if (!costs) return

    if (costs[0] === costs[1] && costs[0] === costs[2]) {
      setDebriefCost("allEquals")
    }
    else if (costs[0] === costs[1] && costs[0] > costs[2]) {
      setDebriefCost("g1g2Equal")
    }
    else if (costs[1] === costs[2] && costs[1] > costs[0]) {
      setDebriefCost("g2g3Equal")
    }
    else if (costs[2] === costs[0] && costs[2] > costs[1]) {
      setDebriefCost("g3g1Equal")
    }
    else if (costs[0] > costs[1] && costs[0] > costs[2]) {
      setDebriefCost("g1More")
    }
    else if (costs[1] > costs[0] && costs[1] > costs[2]) {
      setDebriefCost("g2More")
    }
    else if (costs[2] > costs[0] && costs[2] > costs[1]) {
      setDebriefCost("g3More")
    }
    else {
      console.warn("Erreur dans ScreenFinal")

      setDebriefCost("allEquals")
    }
  }, [costs])

  const getBlockOrder = (item) => {
    return AppState.selection.blocks.indexOf(item.blockRef)
  }

  return (
    <div className={classes.ScreenFinal}>

      <img className={classes.logo} src={logo} />

      <Rays className={classes.rays} />

      <WaveSection globalClasses={`${classes.WaveSection}`} contentClasses={`${classes.content}`} color="#fff">
        <div className={classes.title}>{Texts.get("Screen-final-title")}</div>
        <div className={classes.SelectionContainer}>
          {
            AppState.selection && AppState.selection.itemSelected.sort((a, b) => getBlockOrder(a) - getBlockOrder(b)).map((item, index) => (
              <Item key={index} item={item} />
            ))
          }
        </div>
        <div className={classes.BlockNames}>
          {
            AppState.selection && AppState.selection.blocks.map((block, index) => (
              <>
                {counts && counts[index] > 0 && <div key={index} className={classes.BlockName} style={{ color: block.borderColor }}>{block.title}</div>}
              </>
            ))
          }
        </div>
        <div className={classes.description}>
          <div dangerouslySetInnerHTML={{ __html: Texts.get("Screen-final-description-intro") }} />
          <ul>
            {debriefType && <li dangerouslySetInnerHTML={{ __html: Texts.get("Screen-final-description-type-" + debriefType) }} />}
            {debriefCost && <li dangerouslySetInnerHTML={{ __html: Texts.get("Screen-final-description-cost-" + debriefCost) }} />}
          </ul>
          <div dangerouslySetInnerHTML={{ __html: Texts.get("Screen-final-description-outro") }} />
        </div>
        <div className={classes.buttons}>
          <Button className={classes.BtnQuit} onClick={() => handleQuit()}>{Texts.get("Screen-final-btn-quit")}</Button>
        </div>


        <div className={classes.chars}>
          <CanvasCharacter className={classes.enfant} char_id="petitFils" forceShow={true} />
        </div>

        <Footer />

      </WaveSection>

    </div>
  );
};

const Item = ({ item }) => {

  let style = {}

  style.backgroundColor = item.blockRef.color
  style.borderColor = item.blockRef.borderColor

  return (
    <div className={classes.Item} style={style}>
      <img src={item.image} alt={item.title} />
      <div className={classes.cost} >
        {item.cost} <RiCoinLine />
      </div>
    </div>
  )
}

export default ScreenFinal;
